import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';

import type { AgentChatProps } from '../config';

export type AgentChatHostProps = Pick<
  AgentChatProps,
  | 'documentMode'
  | 'documentID'
  | 'documentName'
  | 'selectedDocumentText'
  | 'onDocumentChanged'
  | 'onOpenDocument'
  | 'onReplaceDocumentSelection'
  | 'onInsertBelowDocumentSelection'
>;

export const AgentChatHostContext = createContext<{
  host: AgentChatHostProps | null;
  setHost: Dispatch<SetStateAction<AgentChatHostProps | null>>;
}>({ host: null, setHost: () => undefined });
